export default __webpack_public_path__ + "static/media/menedchm.450c0284.pdf";